export default{sources:{avif:"__VITE_ASSET__mIcVyA9G__ 400w",webp:"__VITE_ASSET__yayNo0KO__ 400w"},img:{src:"__VITE_ASSET__BIEETLYV__",w:400,h:349}};